const useTimeZoneStyle = () => {
  return {
    height: '48px',
    padding: '8px 12px',
  };
};
export { useTimeZoneStyle };
